export default "__VITE_ASSET__DSq6Jcb$__"